module.exports = __webpack_public_path__ + "static/media/kb.988bc07a.png";